import { LOGIN_PROPERTY } from './constants'

export default {
  email: {
    name: LOGIN_PROPERTY,
    type: 'email',
    label: 'Email Address',
    required: true,
    'data-at-forgotpasswordmodal-email': true
  }
}
